export const SETTLEMENT_TYPE = [
  { id: 'CASH', displayValue: 'Cash' },
  { id: 'PHYSICAL', displayValue: 'Physical' },
  { id: 'CASH_OR_PHYSICAL', displayValue: 'Cash or Physical' },
];
